var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.637,
    height: 19.003,
    viewBox: "0 0 20.637 19.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_100",
    "data-name": "Subtraction 100",
    d: "M-12703-335.5h-16.368a1.644,1.644,0,0,1-1.155-.479,1.638,1.638,0,0,1-.479-1.159v-4.91l1.57-10.069a1.629,1.629,0,0,1,1.615-1.386h13.266a1.629,1.629,0,0,1,1.615,1.386l1.57,10.069v4.91a1.638,1.638,0,0,1-.479,1.159A1.645,1.645,0,0,1-12703-335.5Zm-14.114-15.548-1.4,9h4.882a2.443,2.443,0,0,0,.72,1.735,2.437,2.437,0,0,0,1.735.72,2.456,2.456,0,0,0,2.451-2.455h4.882l-1.405-9h-11.86Z",
    transform: "translate(12721.5 354.001)",
    fill: "#ee5050",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.47171d166b865f30e43d8779df6ed5e1.svg";
export { ForwardRef as ReactComponent };